export enum SubscriptionStatus {
  subscribed,
  soonExpired,
  expired,
  cancelled
}
